<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col v-if="action == 'add'" cols="12">
                            <v-autocomplete
                                v-model="program_id"
                                @update:model-value="loadCourse"
                                label="Program / Department"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="programData"
                                item-title="name"
                                item-value="id"
                                :readonly="action == 'view'"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-if="action == 'add'" cols="12" md="4">
                            <v-autocomplete
                                v-model="code"
                                @update:model-value="loadCodeAndTitle"
                                label="Course Code"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="courseData"
                                item-title="code"
                                item-value="id"
                                return-object
                                :readonly="action == 'view'"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col v-else cols="12" md="4">
                            <v-text-field
                                v-model="code"
                                readonly
                                label="Course Code"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="title"
                                readonly
                                label="Course Title"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="unit"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="time"
                                hint="Ex. 8:00-10:00 AM or 1:00-3:00 PM"
                                label="Time"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="day"
                                hint="Ex. MWF or TTh"
                                label="Days"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="room"
                                label="Room"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="section_code"
                                label="Section Code"
                                hint="Ex. BSIT 1-A"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="class_size"
                                label="Class Size"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="hours_lecture"
                                label="Lecture Hours (a)"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="hours_lab"
                                label="Lab Hours"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="actual_contact_teaching"
                                readonly
                                label="Actual Contact Teaching Hrs/Wk"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="eqv"
                                readonly
                                label=".75 Eqv. (b)"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="total_eqv"
                                readonly
                                label="Total Load Eqv."
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action == 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="course_type"
                                :rules="[formRules.required]"
                                label="Course Type"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="courseTypeData"
                                item-title="name"
                                item-value="name"
                                :readonly="action == 'view'"
                                >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" v-if="action != 'view'" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { load } from 'webfontloader';

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            code: null,
            title: null,
            section_code: null,
            time: null,
            day: null,
            room: null,
            unit: null,
            class_size: null,
            hours_lecture: null,
            hours_lab: null,
            user_id: null,
            course_type: null,
            loaded_by: null,

            program_id: null,
            course: null,

            programData: [],
            courseData: [],

            courseTypeData: [
                { name: 'Major Subject' },
                { name: 'General Education' },
                { name: 'Professional Education' },
                { name: 'Graduate School' },
            ],

            newFormRules: {

            },
        }
     },
     computed: {
        actual_contact_teaching() {
            return parseFloat(this.hours_lecture || 0) + parseFloat(this.hours_lab || 0);
        },
        eqv() {
            return this.hours_lab ? this.hours_lab * 0.75 : 0;
        },
        total_eqv() {
            return parseFloat(this.hours_lecture || 0) + this.eqv;
        }
    },
     methods: {
        async initAdd(){
            this.dialog = true
            this.dialog_title = 'Course Load'
            this.dialog_sub_title = 'Add new course load'
            this.action = 'add'

            this.user_id = this.$store.state.user.id

            await this.loadProgram()
            this.program_id = this.$store.state.user.program.id
            await this.loadCourse()
        },
        async initProgChairAdd(userId, programId){
            this.dialog = true
            this.dialog_title = 'Course Load'
            this.dialog_sub_title = 'Add new course load'
            this.action = 'add'

            this.user_id = userId

            await this.loadProgram()
            this.program_id = programId
            await this.loadCourse()
        },
        async initDirectorAdd(userId, programId){
            this.dialog = true
            this.dialog_title = 'Course Load'
            this.dialog_sub_title = 'Add new course load'
            this.action = 'add'

            this.user_id = userId

            await this.loadProgram()
            this.program_id = programId
            await this.loadCourse()
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Course Load'
            this.dialog_sub_title = 'Update course load details'
            this.action = 'edit'

            this.id = data.id
            this.code = data.code
            this.title = data.title
            this.section_code = data.section_code
            this.time = data.time
            this.day = data.day
            this.room = data.room
            this.unit = data.unit
            this.class_size = data.class_size
            this.hours_lecture = data.hours_lecture
            this.hours_lab = data.hours_lab
            this.actual_contact_teaching = data.actual_contact_teaching
            this.eqv = data.eqv
            this.total_eqv = data.total_eqv
            this.user_id = data.user_id
            this.course_type = data.course_type
            this.program_id = data.program_id
        },
        initView(data){
            this.dialog = true
            this.dialog_title = 'Course Load'
            this.dialog_sub_title = 'View course load details'
            this.action = 'view'

            this.id = data.id
            this.code = data.code
            this.title = data.title
            this.section_code = data.section_code
            this.time = data.time
            this.day = data.day
            this.room = data.room
            this.unit = data.unit
            this.class_size = data.class_size
            this.hours_lecture = data.hours_lecture
            this.hours_lab = data.hours_lab
            this.actual_contact_teaching = data.actual_contact_teaching
            this.eqv = data.eqv
            this.total_eqv = data.total_eqv
            this.user_id = data.user_id
            this.course_type = data.course_type
            this.program_id = data.program_id
        },
        async loadProgram(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });
        },
        async loadCourse(){
            this.code = null
            this.title = null
            this.section_code = null
            this.time = null
            this.day = null
            this.room = null
            this.unit = null
            this.class_size = null
            this.hours_lecture = null
            this.hours_lab = null
            this.course_type = null

            await axios.get(process.env.VUE_APP_SERVER_URL + '/course/findAllActiveCourseByProgram/' + this.program_id)
            .then(res => {
                this.courseData = res.data
            });
        },
        loadCodeAndTitle(data){
            if(data){
                this.code = data.code
                this.title = data.title
                this.unit = data.unit
                this.hours_lab = data.hours_lab != 0 ? data.hours_lab * 3 : 0
                this.hours_lecture = data.hours_lecture
            }
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    code: this.code,
                    title: this.title,
                    section_code: this.section_code,
                    time: this.time,
                    day: this.day,
                    room: this.room,
                    unit: this.unit,
                    class_size: this.class_size,
                    hours_lecture: this.hours_lecture,
                    hours_lab: this.hours_lab,
                    actual_contact_teaching: this.actual_contact_teaching,
                    eqv: this.eqv,
                    total_eqv: this.total_eqv,
                    semester_schoolyear_id: this.$store.state.semester_schoolyear.id,
                    user_id: this.user_id,
                    course_type: this.course_type,
                    program_id: this.program_id,
                    loaded_by: this.$store.state.user.id,
                }

                const token = localStorage.getItem('aums-token')
                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/faculty-load', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 201){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Subject Load successfully added!')
                            this.$refs.form.reset()
                            this.closeDialog()
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/faculty-load', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 201){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Subject Load successfully updated!')
                            this.$refs.form.reset()
                            this.closeDialog()
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.deadline = null
            this.deadline_extension = null
            this.term_id = null,
            this.is_extended = false
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>